import { cloneElement, Fragment, MouseEventHandler } from 'react';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {
  DevHubAccordion,
  DevHubAccordionDetails,
  DevHubAccordionSummary,
  DevHubBox,
  DevHubCard,
  DevHubDivider,
  DevHubList,
  DevHubListItem,
  DevHubListItemIcon,
  DevHubListItemText,
} from '@devxdiscover/devhub-ui';

type DevHubAccordionProps = {
  name: string;
  accordionData: Array<{
    value: string;
    name: string;
    icon: JSX.Element;
  }>;
  selected: string;
  label: string;
  toggleExpanded?(): void;
  expanded?: boolean;
  onClick(source: string): MouseEventHandler<HTMLDivElement> | undefined;
};

/**
 * A custom search filter component
 * @param props - {@link DevHubAccordionProps}
 * @public
 */
const CustomSearchFilter = (props: DevHubAccordionProps) => {
  const { name, label, accordionData, selected } = props;
  return (
    <DevHubCard
      title={name}
      body={
        <DevHubAccordion
          expanded={props?.expanded}
          onChange={props?.toggleExpanded}
        >
          <DevHubAccordionSummary
            expandIcon={<ExpandMoreIcon />}
            IconButtonProps={{ size: 'small' }}
          >
            {props.expanded
              ? 'Collapse'
              : accordionData.filter(t => t.value === selected)[0]!.name}
          </DevHubAccordionSummary>
          <DevHubAccordionDetails>
            <DevHubBox width="100%">
              <DevHubList
                component="nav"
                aria-label={label}
                disablePadding
                dense
              >
                {accordionData?.map(data => (
                  <Fragment key={data.value}>
                    <DevHubDivider />
                    <DevHubListItem
                      selected={data.value === props.selected}
                      onClick={props.onClick(data.value)}
                      button
                    >
                      <DevHubListItemIcon>
                        {cloneElement(data.icon)}
                      </DevHubListItemIcon>
                      <DevHubListItemText primary={data.name} />
                    </DevHubListItem>
                  </Fragment>
                ))}
              </DevHubList>
            </DevHubBox>
          </DevHubAccordionDetails>
        </DevHubAccordion>
      }
    />
  );
};

export default CustomSearchFilter;
